<template>
  <div class="min-h-screen bg-gray-50">
    <div class="container mx-auto px-4 py-8 max-w-7xl">
      <!-- Header -->
      <!-- <div class="mb-8">
        <h1 class="text-3xl font-bold text-gray-900 flex items-center">
          Call Attempts
          <span
            class="ml-3 text-sm font-normal text-gray-500 bg-white px-3 py-1 rounded-full shadow-sm"
          >
            {{ totalCalls }} total attempts
          </span>
        </h1>
        <p class="text-lg text-gray-600 mt-1">
          Track and analyze all call attempts across verification tickets
        </p>
      </div> -->

      <!-- Date Range Selector -->
      <!-- <div
        class="bg-white rounded-xl shadow-sm p-6 border border-gray-100 mb-8"
      >
        <div
          class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4"
        >
          <div class="flex items-center space-x-4">
            <div class="relative">
              <select
                v-model="dateRange"
                class="pl-4 pr-10 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none bg-white"
              >
                <option value="today">Today</option>
                <option value="yesterday">Yesterday</option>
                <option value="last7">Last 7 Days</option>
                <option value="last30">Last 30 Days</option>
                <option value="thisMonth">This Month</option>
                <option value="custom">Custom Range</option>
              </select>
              <svg
                class="w-4 h-4 text-gray-400 absolute right-3 top-3 pointer-events-none"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>

            <div
              v-if="dateRange === 'custom'"
              class="flex items-center space-x-2"
            >
              <input
                type="date"
                v-model="customStartDate"
                class="border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <span class="text-gray-500">to</span>
              <input
                type="date"
                v-model="customEndDate"
                class="border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <div class="flex items-center space-x-3">
            <button
              @click="exportCalls"
              class="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors flex items-center"
            >
              <svg
                class="w-4 h-4 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              EXPORT
            </button>
          </div>
        </div>
      </div> -->

      <!-- Stats Cards -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
        <div class="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
          <div class="flex items-center justify-between mb-2">
            <span class="text-sm font-medium text-gray-500">Total Calls</span>
          </div>
          <p class="text-2xl font-bold text-gray-900">
            {{ formatNumber(stats.totalCalls) }}
          </p>
          <!-- <p class="text-xs text-green-600 mt-1">
            ↑ {{ stats.callsGrowth }}% vs last period
          </p> -->
        </div>

        <div class="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
          <div class="flex items-center justify-between mb-2">
            <span class="text-sm font-medium text-gray-500">Successful</span>
          </div>
          <p class="text-2xl font-bold text-green-600">
            {{ formatNumber(stats.successful) }}
          </p>
          <!-- <p class="text-xs text-gray-500 mt-1">
            {{ stats.successRate }}% success rate
          </p> -->
        </div>

        <div class="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
          <div class="flex items-center justify-between mb-2">
            <span class="text-sm font-medium text-gray-500">No Answer</span>
          </div>
          <p class="text-2xl font-bold text-yellow-600">
            {{ formatNumber(stats.noAnswer) }}
          </p>
          <!-- <p class="text-xs text-gray-500 mt-1">
            {{ stats.noAnswerRate }}% of total
          </p> -->
        </div>

        <div class="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
          <div class="flex items-center justify-between mb-2">
            <span class="text-sm font-medium text-gray-500">Wrong Numbers</span>
          </div>
          <p class="text-2xl font-bold text-red-600">
            {{ formatNumber(stats.wrongNumber) }}
          </p>
          <!-- <p class="text-xs text-gray-500 mt-1">
            {{ stats.wrongNumberRate }}% of total
          </p> -->
        </div>

        <div class="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
          <div class="flex items-center justify-between mb-2">
            <span class="text-sm font-medium text-gray-500">Avg. Duration</span>
          </div>
          <p class="text-2xl font-bold text-gray-900">
            {{ stats.avgDuration }}
          </p>
          <!-- <p class="text-xs text-gray-500 mt-1">per call</p> -->
        </div>
      </div>

      <!-- Filters Bar -->
      <div
        class="bg-white rounded-xl shadow-sm p-6 border border-gray-100 mb-6"
      >
        <div class="flex flex-col lg:flex-row gap-4">
          <!-- Search -->
          <div class="flex-1 relative">
            <div
              class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
            >
              <svg
                class="h-5 w-5 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </div>
            <input
              v-model="filters.search"
              type="text"
              placeholder="Search by ticket, customer, or officer..."
              class="block w-full pl-10 pr-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <!-- Outcome Filter -->
          <div class="w-full lg:w-48">
            <select
              v-model="filters.outcome"
              class="block w-full pl-3 pr-10 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">All Outcomes</option>
              <option value="reached">Reached</option>
              <option value="confirmed">Confirmed</option>
              <option value="no_answer">No Answer</option>
              <option value="busy">Busy</option>
              <option value="wrong_number">Wrong Number</option>
              <option value="not_reachable">Not Reachable</option>
              <option value="call_back_later">Call Back Later</option>
              <option value="denied_relationship">Denied Relationship</option>
              <option value="language_barrier">Language Barrier</option>
              <option value="deceased">Deceased</option>
              <option value="other">Other</option>
            </select>
          </div>

          <!-- Officer Filter -->
          <div class="w-full lg:w-48">
            <select
              v-model="filters.officer"
              class="block w-full pl-3 pr-10 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">All Officers</option>
              <option
                v-for="officer in officers"
                :key="officer.id"
                :value="officer.id"
              >
                {{ officer.name }}
              </option>
            </select>
          </div>

          <!-- Contact Type Filter -->
          <div class="w-full lg:w-40">
            <select
              v-model="filters.contactType"
              class="block w-full pl-3 pr-10 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">All Types</option>
              <option value="customer">Customer</option>
              <option value="emergency">Emergency</option>
            </select>
          </div>

          <!-- Reset Button -->
          <button
            @click="resetFilters"
            class="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-900 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors flex items-center"
          >
            <svg
              class="w-4 h-4 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
            RESET
          </button>
        </div>
      </div>

      <!-- Call Attempts Table -->
      <div
        class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden"
      >
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Time
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Ticket
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Contact
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Officer
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Outcome
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Attempt
                </th>
                <!-- <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Notes
                </th> -->
                <!-- <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Actions
                </th> -->
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-if="filteredCalls.length === 0">
                <td colspan="8" class="px-6 py-12 text-center">
                  <div class="flex flex-col items-center">
                    <svg
                      class="w-12 h-12 text-gray-300 mb-3"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                      />
                    </svg>
                    <p class="text-gray-500 text-lg mb-1">
                      No call attempts found
                    </p>
                    <p class="text-gray-400 text-sm">
                      Try adjusting your search or filters
                    </p>
                  </div>
                </td>
              </tr>
              <tr
                v-for="call in paginatedCalls"
                :key="call.id"
                class="hover:bg-gray-50 transition-colors"
              >
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm text-gray-900">
                    {{ call.date }}
                  </div>
                  <div class="text-xs text-gray-500">
                    {{ call.time }}
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm font-medium text-gray-900">
                    {{ call.ticket_string }}
                  </div>
                  <div class="text-xs text-gray-500">
                    {{ call.client_string }}
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm text-gray-900">
                    {{ call.contact_name }}
                  </div>
                  <div class="text-xs text-gray-500 flex items-center mt-1">
                    <span class="ml-2">{{ call.phone_number }}</span>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="flex items-center">
                    <!-- <img
                      :src="call?.officer?.avatar"
                      :alt="call?.officer?.name"
                      class="w-6 h-6 rounded-full mr-2"
                    /> -->
                    <span class="text-sm text-gray-900">{{
                      call?.user_string
                    }}</span>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <OutcomeBadge :outcome="call.summary" />
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  #{{ call.attempt_count }}
                </td>
                <!-- <td class="px-6 py-4 max-w-xs">
                  <p class="text-sm text-gray-600 truncate">
                    {{ call.notes || "—" }}
                  </p>
                </td> -->
                <!-- <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <div class="flex items-center space-x-2">
                    <button
                      @click="viewTicket(call)"
                      class="text-blue-600 hover:text-blue-900 p-1 rounded hover:bg-blue-50"
                      title="View ticket"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        />
                      </svg>
                    </button>
                    <button
                      @click="viewCallDetails(call)"
                      class="text-purple-600 hover:text-purple-900 p-1 rounded hover:bg-purple-50"
                      title="View details"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </button>
                  </div>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div
          class="px-6 py-4 border-t border-gray-100 flex items-center justify-between"
        >
          <div class="flex items-center space-x-2">
            <span class="text-sm text-gray-500">Items per page:</span>
            <select
              v-model="itemsPerPage"
              class="border border-gray-200 rounded-lg text-sm py-1 px-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>

          <div class="flex items-center space-x-4">
            <span class="text-sm text-gray-500">
              {{ paginationStart }}-{{ paginationEnd }} of
              {{ filteredCalls.length }}
            </span>
            <div class="flex items-center space-x-2">
              <button
                @click="currentPage--"
                :disabled="currentPage === 1"
                class="p-1 rounded hover:bg-gray-100 disabled:opacity-50"
              >
                <svg
                  class="w-5 h-5 text-gray-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </button>
              <span class="text-sm text-gray-700"
                >Page {{ currentPage }} of {{ totalPages }}</span
              >
              <button
                @click="currentPage++"
                :disabled="currentPage === totalPages"
                class="p-1 rounded hover:bg-gray-100 disabled:opacity-50"
              >
                <svg
                  class="w-5 h-5 text-gray-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Call Details Modal -->
      <div v-if="showDetailsModal" class="fixed inset-0 z-50 overflow-y-auto">
        <div
          class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <div
            class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            @click="closeDetailsModal"
          ></div>

          <div
            class="inline-block align-bottom bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full"
          >
            <div class="bg-white px-6 pt-5 pb-4 sm:p-6">
              <div class="flex items-center justify-between mb-4">
                <h3 class="text-lg font-semibold text-gray-900">
                  Call Attempt Details
                </h3>
                <button
                  @click="closeDetailsModal"
                  class="text-gray-400 hover:text-gray-600"
                >
                  <svg
                    class="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              <div v-if="selectedCall" class="space-y-6">
                <!-- Call Info Grid -->
                <div class="grid grid-cols-2 gap-4">
                  <div class="bg-gray-50 p-4 rounded-lg">
                    <p class="text-xs text-gray-500 mb-1">Ticket Number</p>
                    <p class="text-sm font-medium text-gray-900">
                      {{ selectedCall.ticketNumber }}
                    </p>
                  </div>
                  <div class="bg-gray-50 p-4 rounded-lg">
                    <p class="text-xs text-gray-500 mb-1">Customer</p>
                    <p class="text-sm font-medium text-gray-900">
                      {{ selectedCall.customerName }}
                    </p>
                  </div>
                  <div class="bg-gray-50 p-4 rounded-lg">
                    <p class="text-xs text-gray-500 mb-1">Date & Time</p>
                    <p class="text-sm font-medium text-gray-900">
                      {{ formatDateTime(selectedCall.timestamp) }}
                    </p>
                  </div>
                  <div class="bg-gray-50 p-4 rounded-lg">
                    <p class="text-xs text-gray-500 mb-1">Attempt Number</p>
                    <p class="text-sm font-medium text-gray-900">
                      #{{ selectedCall.attemptNumber }}
                    </p>
                  </div>
                </div>

                <!-- Contact Info -->
                <div class="border-t border-gray-100 pt-4">
                  <h4 class="text-sm font-medium text-gray-700 mb-3">
                    Contact Information
                  </h4>
                  <div class="grid grid-cols-2 gap-4">
                    <div>
                      <p class="text-xs text-gray-500">Name</p>
                      <p class="text-sm text-gray-900">
                        {{ selectedCall.contactName }}
                      </p>
                    </div>
                    <div>
                      <p class="text-xs text-gray-500">Type</p>
                      <p class="text-sm text-gray-900 capitalize">
                        {{ selectedCall.contactType }}
                      </p>
                    </div>
                    <div>
                      <p class="text-xs text-gray-500">Phone Number</p>
                      <p class="text-sm text-gray-900">
                        {{ selectedCall.phoneNumber }}
                      </p>
                    </div>
                    <div>
                      <p class="text-xs text-gray-500">Relationship</p>
                      <p class="text-sm text-gray-900">
                        {{ selectedCall.relationship || "Self" }}
                      </p>
                    </div>
                  </div>
                </div>

                <!-- Officer Info -->
                <div class="border-t border-gray-100 pt-4">
                  <h4 class="text-sm font-medium text-gray-700 mb-3">
                    Verification Officer
                  </h4>
                  <div class="flex items-center">
                    <img
                      :src="selectedCall?.officer?.avatar"
                      :alt="selectedCall?.officer?.name"
                      class="w-10 h-10 rounded-full mr-3"
                    />
                    <div>
                      <p class="text-sm font-medium text-gray-900">
                        {{ selectedCall?.officer?.name }}
                      </p>
                      <p class="text-xs text-gray-500">
                        {{ selectedCall?.officer?.email }}
                      </p>
                    </div>
                  </div>
                </div>

                <!-- Outcome -->
                <div class="border-t border-gray-100 pt-4">
                  <h4 class="text-sm font-medium text-gray-700 mb-3">
                    Outcome
                  </h4>
                  <div class="flex items-center space-x-4">
                    <OutcomeBadge :outcome="selectedCall.outcome" />
                    <span class="text-sm text-gray-600">{{
                      getOutcomeDescription(selectedCall.outcome)
                    }}</span>
                  </div>
                </div>

                <!-- Notes -->
                <div
                  v-if="selectedCall.notes"
                  class="border-t border-gray-100 pt-4"
                >
                  <h4 class="text-sm font-medium text-gray-700 mb-3">Notes</h4>
                  <p class="text-sm text-gray-600 bg-gray-50 p-3 rounded-lg">
                    {{ selectedCall.notes }}
                  </p>
                </div>

                <!-- Next Steps -->
                <div
                  v-if="selectedCall.nextStep"
                  class="border-t border-gray-100 pt-4"
                >
                  <h4 class="text-sm font-medium text-gray-700 mb-3">
                    Next Steps
                  </h4>
                  <div class="bg-blue-50 p-3 rounded-lg">
                    <p class="text-sm text-blue-700">
                      {{ selectedCall.nextStep }}
                    </p>
                    <p
                      v-if="selectedCall.callbackTime"
                      class="text-xs text-blue-600 mt-1"
                    >
                      Callback scheduled for
                      {{ formatDateTime(selectedCall.callbackTime) }}
                    </p>
                  </div>
                </div>

                <!-- Actions -->
                <div
                  class="border-t border-gray-100 pt-4 flex justify-end space-x-3"
                >
                  <button
                    @click="viewTicket(selectedCall)"
                    class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                  >
                    View Full Ticket
                  </button>
                  <button
                    @click="closeDetailsModal"
                    class="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Floating Action Button -->
    <button
      @click="getCallAttempts"
      class="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-indigo-800 text-white shadow-lg transition-all duration-300 hover:bg-indigo-700 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      aria-label="Refresh page"
    >
      <!-- Refresh icon (SVG) -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        :class="{ 'animate-spin': isRefreshing }"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        />
      </svg>
    </button>
  </div>

  <div
    v-if="isRefreshing"
    class="fixed inset-0 ml-64 bg-white/80 backdrop-blur-sm flex items-center justify-center z-50"
  >
    <div class="relative">
      <!-- Outer ring -->
      <div class="w-16 h-16 border-4 border-gray-200 rounded-full"></div>
      <!-- Inner spinning gradient ring -->
      <div
        class="w-16 h-16 border-4 border-transparent rounded-full absolute top-0 left-0 border-t-indigo-500 border-r-indigo-700 animate-spin"
      ></div>
      <!-- Center dot -->
      <div
        class="w-3 h-3 bg-indigo-800 rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import OutcomeBadge from "@/components/ui/OutcomeBadge.vue";
import api from "@/utils/api";

import { useNotifications } from "@/composables/useNotifications";

// Notification system
const { showError, formatValidationErrors } = useNotifications();

const router = useRouter();

// State
const isRefreshing = ref(false);

// Date range state
const dateRange = ref("last30");
const customStartDate = ref("");
const customEndDate = ref("");

// Filters
const filters = ref({
  search: "",
  outcome: "",
  officer: "",
  contactType: "",
});

// Pagination
const currentPage = ref(1);
const itemsPerPage = ref(25);

// Modal state
const showDetailsModal = ref(false);
const selectedCall = ref(null);

// Officers list
const officers = ref([
  // {
  //   id: 1,
  //   name: "John Doe",
  //   email: "john.doe@example.com",
  //   avatar:
  //     "https://ui-avatars.com/api/?name=John+Doe&background=3b82f6&color=fff",
  // },
]);

// Mock call attempts data
const callAttempts = ref([
  // {
  //   id: 1,
  //   ticketNumber: "TKT-2026-0123",
  //   customerName: "Alice Johnson",
  //   contactName: "Alice Johnson",
  //   contactType: "customer",
  //   phoneNumber: "+1 234-567-8901",
  //   relationship: null,
  //   outcome: "reached",
  //   attemptNumber: 1,
  //   notes: "Customer confirmed identity and provided additional information",
  //   timestamp: "2026-02-25T10:30:00",
  //   officer: officers.value[0],
  //   nextStep: null,
  // },
]);

// Stats
const totalCalls = computed(() => callAttempts.value.length);

const stats = computed(() => {
  const successful = callAttempts.value.filter((c) =>
    ["reached", "confirmed"].includes(c.outcome)
  ).length;
  const noAnswer = callAttempts.value.filter((c) =>
    ["no_answer", "busy"].includes(c.outcome)
  ).length;
  const wrongNumber = callAttempts.value.filter(
    (c) => c.outcome === "wrong_number"
  ).length;

  return {
    totalCalls,
    successful,
    noAnswer,
    wrongNumber,
    callsGrowth: 12,
    successRate: ((successful / totalCalls.value) * 100).toFixed(1),
    noAnswerRate: ((noAnswer / totalCalls.value) * 100).toFixed(1),
    wrongNumberRate: ((wrongNumber / totalCalls.value) * 100).toFixed(1),
    avgDuration: "0:00",
  };
});

// Calls over time for chart
// const callsOverTime = ref([
//   { label: "Mon", date: "Feb 24", successful: 12, failed: 5 },
//   { label: "Tue", date: "Feb 25", successful: 15, failed: 7 },
//   { label: "Wed", date: "Feb 26", successful: 8, failed: 4 },
//   { label: "Thu", date: "Feb 27", successful: 10, failed: 6 },
//   { label: "Fri", date: "Feb 28", successful: 14, failed: 8 },
//   { label: "Sat", date: "Mar 1", successful: 6, failed: 2 },
//   { label: "Sun", date: "Mar 2", successful: 4, failed: 1 },
// ]);

// Outcome distribution
// const outcomeDistribution = computed(() => {
//   const outcomes = {};
//   callAttempts.value.forEach((call) => {
//     outcomes[call.outcome] = (outcomes[call.outcome] || 0) + 1;
//   });

//   return Object.entries(outcomes)
//     .map(([key, count]) => {
//       const percentage = ((count / totalCalls.value) * 100).toFixed(1);
//       let colorClass = "";

//       switch (key) {
//         case "reached":
//         case "confirmed":
//           colorClass = "bg-green-500";
//           break;
//         case "no_answer":
//         case "busy":
//           colorClass = "bg-yellow-500";
//           break;
//         case "wrong_number":
//         case "not_reachable":
//           colorClass = "bg-red-500";
//           break;
//         case "call_back_later":
//           colorClass = "bg-blue-500";
//           break;
//         case "denied_relationship":
//           colorClass = "bg-orange-500";
//           break;
//         case "language_barrier":
//           colorClass = "bg-purple-500";
//           break;
//         case "deceased":
//           colorClass = "bg-gray-500";
//           break;
//         default:
//           colorClass = "bg-gray-400";
//       }

//       return {
//         label: key.replace("_", " ").replace(/\b\w/g, (l) => l.toUpperCase()),
//         count,
//         percentage,
//         colorClass,
//       };
//     })
//     .sort((a, b) => b.count - a.count);
// });

// Pie chart segments
// const pieSegments = computed(() => {
//   const colors = {
//     reached: "#10b981",
//     confirmed: "#10b981",
//     no_answer: "#f59e0b",
//     busy: "#f59e0b",
//     wrong_number: "#ef4444",
//     not_reachable: "#ef4444",
//     call_back_later: "#3b82f6",
//     denied_relationship: "#f97316",
//     language_barrier: "#8b5cf6",
//     deceased: "#6b7280",
//     other: "#9ca3af",
//   };

//   let rotation = 0;
//   return outcomeDistribution.value.map((outcome) => {
//     const segment = {
//       color: colors[outcome.label.toLowerCase().replace(" ", "_")] || "#9ca3af",
//       percentage: parseFloat(outcome.percentage),
//       rotation,
//     };
//     rotation += outcome.percentage * 3.6;
//     return segment;
//   });
// });

// Filtered calls
const filteredCalls = computed(() => {
  return callAttempts.value.filter((call) => {
    // Search filter
    const matchesSearch =
      !filters.value.search ||
      call.ticket_number
        .toLowerCase()
        .includes(filters.value.search.toLowerCase()) ||
      call.user_string
        .toLowerCase()
        .includes(filters.value.search.toLowerCase()) ||
      call.client_string
        .toLowerCase()
        .includes(filters.value.search.toLowerCase());
    // Outcome filter
    const matchesOutcome =
      !filters.value.outcome || call.outcome === filters.value.outcome;

    // Officer filter
    const matchesOfficer =
      !filters.value.officer ||
      call.officer.id === parseInt(filters.value.officer);

    // Contact type filter
    const matchesContactType =
      !filters.value.contactType ||
      call.contactType === filters.value.contactType;

    return (
      matchesSearch && matchesOutcome && matchesOfficer && matchesContactType
    );
  });
});

// Pagination
const paginatedCalls = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  const end = start + itemsPerPage.value;
  return filteredCalls.value.slice(start, end);
});

const totalPages = computed(() =>
  Math.ceil(filteredCalls.value.length / itemsPerPage.value)
);
const paginationStart = computed(
  () => (currentPage.value - 1) * itemsPerPage.value + 1
);
const paginationEnd = computed(() =>
  Math.min(currentPage.value * itemsPerPage.value, filteredCalls.value.length)
);

// Helper functions
const formatNumber = (num) => {
  return new Intl.NumberFormat().format(num);
};

// const formatDate = (timestamp) => {
//   const date = new Date(timestamp);
//   return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
// };

// const formatTime = (timestamp) => {
//   const date = new Date(timestamp);
//   return date.toLocaleTimeString("en-US", {
//     hour: "2-digit",
//     minute: "2-digit",
//   });
// };

const formatDateTime = (timestamp) => {
  const date = new Date(timestamp);
  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    year: "numeric",
  });
};

const getOutcomeDescription = (outcome) => {
  const descriptions = {
    reached: "Successfully reached the contact",
    confirmed: "Contact confirmed information",
    no_answer: "No answer after multiple rings",
    busy: "Line was busy",
    wrong_number: "Phone number belongs to wrong person",
    not_reachable: "Phone is switched off or out of service",
    call_back_later: "Contact requested to call back later",
    denied_relationship: "Contact denied knowing the customer",
    language_barrier: "Unable to communicate due to language",
    deceased: "Contact informed that customer is deceased",
    other: "Other outcome",
  };
  return descriptions[outcome] || outcome;
};

// Actions
const resetFilters = () => {
  filters.value = {
    search: "",
    outcome: "",
    officer: "",
    contactType: "",
  };
  currentPage.value = 1;
};

const viewTicket = (call) => {
  router.push(`/tickets/${call.ticketNumber.split("-")[1]}`);
};

// const viewCallDetails = (call) => {
//   selectedCall.value = call;
//   showDetailsModal.value = true;
// };

const closeDetailsModal = () => {
  showDetailsModal.value = false;
  selectedCall.value = null;
};

// const exportCalls = () => {
//   // Implement export functionality
//   console.log("Exporting calls...");
// };

const getCallAttempts = async () => {
  isRefreshing.value = true;
  try {
    const response = await api.get("/api/v1/call-attempts");
    callAttempts.value = response.data.data;
  } catch (error) {
    console.log(error);
    const details = formatValidationErrors(error);
    showError("Error", "Failed to save user", details, 5000);
  } finally {
    isRefreshing.value = false;
  }
};

// Watch for filter changes
watch(
  [filters, dateRange],
  () => {
    currentPage.value = 1;
  },
  { deep: true }
);

// Initialize
onMounted(() => {
  const today = new Date();
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(today.getDate() - 30);

  customStartDate.value = thirtyDaysAgo.toISOString().split("T")[0];
  customEndDate.value = today.toISOString().split("T")[0];

  getCallAttempts();
});
</script>
